import { render, staticRenderFns } from "./StudentPicker.vue?vue&type=template&id=5d70d522"
import script from "./StudentPicker.vue?vue&type=script&lang=js"
export * from "./StudentPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports